const strings = {
  super_admin: "مدیر کل",
  unregistered: "ثبت نشده",

  lead: "سرنخ",
  about_us: "درباره ما",
  contact_us: "ارتباط با ما",

  app_version: "ورژن برنامه",

  app_version_code: "ورژن کد برنامه",

  number_type_error: "مقدار عددی وارد کنید",
  pick_employee_role: "نقش کارمند را انتخاب کنید",

  corp: "شرکت",
  corps: "شرکت ها",

  countries: "کشور/استان/شهر جدید",

  force_update: "بروزرسانی اجباری",

  //
  status: "وضعیت",
  add_new_factor_item: "افزودن محصولات جدید به سفارش",
  group_replace: "انتقال گروهی",
  group: "گروه",
  view_all_notes: "همه یادداشت‌ها",
  changing_customer_group: "تغییر گروه مشتری",
  users: "کاربران",
  user_permissions: (user: string) => `مجوزهای کارمند: ${user}`,
  accept: "تایید سفارش",
  reject: "رد سفارش",
  draft_awaiting_review: "در انتظار بررسی",
  rejected: "رد شده",
  accepted: "تأیید شده",
  binary: "جفتی",
  recommended: "توصیه میکنم",
  discounted: "تخفیف دار",
  upgrade: "بروزرسانی",
  pictures: "تصاویر",
  add_wholesaler: "افزودن بنکدار",
  wholesaler: "بنکدار",
  wholesalers: "بنکداران",
  company_infos: "اطلاعات شرکت",
  companies_db: "بانک اطلاعات شرکت‌ها",
  personal_note: "یادداشت شخصی",
  all_today_reminders: "همه یادآورهای امروز",
  buy_status: "نحوه خرید",
  buy_ability: "قدرت خرید",
  buy_ability_desc: "تعداد در ماه",
  insert_buy_ability: "تعداد را وارد کنید",
  bank_account_creation_date: "زمان افتتاح حساب بانکی",
  pick_bank_account_creation_date: "زمان افتتاح حساب را انتخاب کنید",
  max_passed_cheque: "حداکثر مبلغ چک های پاس شده",
  passed_cheque_amount: "حداکثر مبلغ چک های پاس شده",
  insert_max_passed_cheque: "حداکثر مبلغ چک را وارد کنید",
  bounced_cheque_count: "تعداد چک های برگشتی",
  insert_bounced_cheque_count: "تعداد چک های برگشتی را وارد کنید",
  credit_by_herself: "استعلام حضوری",
  insert_credit_by_herself: "نتیجه استعلام حضوری را وارد کنید",
  credit_by_co_workers: "استعلام از همکاران",
  insert_credit_by_co_workers: "نتیجه استعلام از همکاران را وارد کنید",
  credit_descriptions: "نتیجه نهایی استعلام",
  insert_credit_descriptions: "نتیجه نهایی استعلام را وارد کنید",
  no_update: "بروزرسانی نشود",
  no_change: "تغییر نکند",
  variants: "تنوع ها",
  no_variant: "تنوعی برای این محصول ثبت نشده است",
  management_system: "سامانه مدیریت فروش",
  selling_carpet: " فرش",
  clear: "پاک کردن",
  call_ways: "راههای ارتباطی",

  sure_to_send_file: (
    filename: string
  ) => ` فایل انتخاب شده، "${filename}" می‌باشد.
  از ارسال این فایل اطمینان دارید؟`,
  sure_to_send_image: "از ارسال تصویر اطمینان دارید؟",

  loc_perm_denied_alert_box_desc:
    "برای انتخاب دقیق موقعیت مکان فعلی بر روی نقشه، نیاز است تا اجازه دسترسی به سرویس موقعیت مکانی در بخش تنظیمات به «سرنخ» داده شود.",
  mic_perm_denied_alert_box_desc:
    "برای استفاده از ضبط صدا، نیاز است تا اجازه دسترسی به میکروفون و حافظه داخلی دستگاه در بخش تنظیمات به «سرنخ» داده شود",
  file_perm_denied_alert_box_desc:
    "برای ارسال فایل و تصویر، نیاز است تا اجازه دسترسی به حافظه داخلی دستگاه در بخش تنظیمات به «سرنخ» داده شود",

  delete_attribute_item_description: [
    { text: "در صورت حذف مقدار ویژگی، ممکن است اطلاعاتی از " },
    { text: "گروه بندی ها، محصولات و فاکتورهای ", b: true },
    { text: "شما تغییر کند" },
  ],

  delete_attribute_description: [
    { text: "در صورت حذف ویژگی، تمام " },
    { text: "مقادیر", b: true },
    { text: " آن حذف شده و ممکن است اطلاعاتی از " },
    { text: "گروه بندی ها، محصولات و فاکتورهای ", b: true },
    { text: "شما تغییر کند" },
  ],

  delete_category_description: [
    { text: "در صورت حذف گروه، تمام " },
    { text: "زیرگروه ها و ویژگی های", b: true },
    { text: " آن حذف شده و ممکن است اطلاعاتی از " },
    { text: "محصولات و فاکتورهای ", b: true },
    { text: "شما تغییر کند" },
  ],

  delete_category_attr_description: [
    { text: "در صورت حذف ویژگی گروه، ممکن است اطلاعاتی از " },
    { text: "محصولات و فاکتورهای ", b: true },
    { text: "شما تغییر کند" },
  ],

  delete_product_description: [
    { text: "در صورت حذف محصول، تمام " },
    { text: "تنوع های ", b: true },
    { text: " آن حذف شده و ممکن است اطلاعاتی از " },
    { text: "فاکتورهای ", b: true },
    { text: "شما تغییر کند" },
  ],

  delete_product_variation_description: [
    { text: "در صورت حذف تنوع محصول، ممکن است اطلاعاتی از " },
    { text: "فاکتورهای ", b: true },
    { text: "شما تغییر کند" },
  ],

  delete_seller_description: [
    { text: "در صورت حذف مدیر فروش، تمام " },
    { text: "اطلاعات ", b: true },
    {
      text: "این مدیر حذف خواهد شد. لطفا قبل از حذف،‌ اطلاعات لازم را انتقال دهید",
    },
  ],

  code_was_send_to: (number: string): string =>
    `کد تایید به شماره ${number} فرستاده شد`,

  price: "قیمت",
  total_factor_amount: "جمع کل",
  empty_factor: "خالی",

  items: "مقادیر ویژگی",
  no_item: "مقداری  برای این ویژگی تبت نشده است",
  attributes: "ویژگی‌ها",
  attribute: "ویژگی",
  without_cat: "بدون گروه بندی",
  category: "گروه",
  categories: "گروه ها",
  customer_category: "گروه مشتری",
  pick_customer_category: "گروه مشتری را انتخاب کنید",
  pick_customer_type: "نوع مشتری را انتخاب کنید",

  not_exists_any_info: "اطلاعاتی برای نمایش وجود ندارد",

  // inputs placeholders and labels

  deleted_customer: "مشتری حذف شده",
  add_description: "افزودن توضیحات",
  edit_description: "ویرایش توضیحات",
  select_group_attr: "انتخاب گروهی ویژگی ها",
  role_title: "عنوان نقش",
  insert_role_title: "عنوان نقش را وارد کنید",
  insert_employee_name: "نام کارمند را وارد کنید",
  insert_employee_mobile: "موبایل کارمند را وارد کنید",
  for_myself: "برای خودم",
  myself: "خودم",
  manager: "مدیر",
  sale: "فروش",
  click_on_item_to_get_reports:
    "برای دریافت گزارش زنده روی هریک از گزینه ها بزنید",

  insert_unit_price: "قیمت واحد محصول را وارد کنید",
  insert_price: "قیمت را وارد کنید",
  insert_product_count: "تعداد محصول را وارد کنید",
  insert_price_ratio: "ضریب قیمت را وارد کنید",
  insert_title: "عنوان را وارد کنید",
  app_link: "لینک برنامه",
  insert_app_link: "لینک برنامه را وارد کنید",
  insert_description: "توضیحات را وارد کنید",
  insert_social_address: "آدرس شبکه اجتماعی را وارد کنید",
  insert_email: "آدرس ایمیل را وارد کنید",
  insert_mobile: "شماره موبایل خود را وارد کنید",
  insert_mobile_number: "شماره موبایل را وارد کنید",
  insert_reminder_title: "عنوان یادآور را وارد کنید",
  insert_reminder_descriptions: "توضیحات یادآور را وارد کنید",
  insert_phone_number: "شماره تلفن را وارد کنید",
  pick_birthday: "تاریخ تولد را انتخاب کنید",
  pick_reminder_date: "تاریخ یادآور را انتخاب کنید",
  pick_reminder_time: "زمان یادآور را انتخاب کنید",
  pick_country: "کشور را انتخاب کنید",
  pick_province: "استان را انتخاب کنید",
  pick_city: "شهر را انتخاب کنید",
  multi_select_city_description: "یک یا چند شهر انتخاب و اعمال کنید",
  pick_phone_type: "نوع تلفن را انتخاب کنید",
  pick_social_type: "شبکه اجتماعی را انتخاب کنید",
  time: "زمان",
  insert_customer_name: "نام مشتری را وارد کنید",
  insert_customer_mobile: "شماره همراه مشتری را وارد کنید",
  insert_customer_descriptions: "توضیحات مربوط به این مشتری را وارد کنید",
  insert_customer_national_code: "کد ملی مشتری را وارد کنید",
  insert_customer_pay_number: "شماره کارت مشتری را وارد کنید",
  insert_customer_website: "وب سایت مشتری (مثلا https://itsaco.ir)",
  insert_customer_role: "سمت مشتری را وارد کنید",
  pick_customer_familiarity_way: "نحوه آشنایی مشتری را انتخاب کنید",
  pick_customer_religion: "دین و مذهب مشتری را انتخاب کنید",
  pick_customer_credit: "اعتبار مشتری را انتخاب کنید",
  pick_customer_birthday: "تاریخ تولد مشتری را انتخاب کنید",
  insert_address: "جزییات آدرس را وارد کنید",
  insert_customized_attributes_description:
    "تعداد و توضیحات مربوط به محصول یا محصولات مورد نظر را وارد کنید",
  count_and_description_for_customized_attributes: "تعداد و توضیحات",
  insert_company_name: "نام شرکت را وارد کنید",
  insert_ceo_name: "نام مدیر عامل را وارد کنید",
  insert_ceo_mobile: "موبایل مدیر عامل را وارد کنید",
  pick_company_color: "رنگ سازمانی را انتخاب کنید",
  insert_unit_product: "واحد شمارش محصول را وارد کنید",
  popular_attrs: "ویژگی های پر استفاده",
  popular_products: "محصولات پر استفاده",
  popular_categories: "گروه های پر استفاده",
  popular_category: "گروه پر استفاده",
  ceo: "مدیرعامل",

  please_waite: "لطفا منتظر بمانید ...",
  on_sending: "در حال ارسال اطلاعات ...",

  parent_cat: "گروه پدر",
  pick_parent_cat: "گروه پدر را انتخاب کنید",
  pick_attr: "ویژگی را انتخاب کنید",
  pick_product_cat: "گروه محصول را انتخاب کنید",
  pick_product_cat_for_first: "ابتدا گروه محصول را انتخاب کنید",
  pick_product: "محصول را انتخاب کنید",

  year_count: "تعداد سال",
  year: "سال",

  insert_attr_value: "مقدار ویژگی را وارد کنید",

  pick: "انتخاب کنید",

  insert_note_title: "عنوان یادداشت را وارد کنید",
  insert_note_descriptions: "توضیحات یادداشت را وارد کنید",

  update_price_descriptions:
    "در صورت تایید، قیمت همه تنوع ها بر اساس قیمت واحد محصول و ضریب قیمت هر تنوع، بروزرسانی خواهد شد",

  empty_attr_items:
    'مقداری برای این ویژگی ثبت نشده است. ابتدا در بخش "ویژگی های محصول" برای این ویژگی، مقدار ثبت کنید',
  pick_attr_items: "یک یا چند مقدار را انتخاب کنید",
  pick_attr_first: "ابتدا ویژگی را انتخاب کنید",

  home: "خانه",
  reports: "گزارشات",
  history: "تاریخچه",
  profile: "پروفایل",
  user_info: "اطلاعات کاربری",

  name: "نام",
  mobile: "موبایل",
  addresses: "آدرس ها",
  address: "آدرس",
  phone: "تلفن",
  phones: "تلفن ها",
  emails: "ایمیل ها",
  email: "ایمیل",
  socials: "شبکه های اجتماعی",
  familiarity_way: "نحوه آشنایی",
  familiarity_date: "تاریخ آشنایی",
  pick_familiarity_date: "تاریخ آشنایی را انتخاب کنید",
  attend_time: "زمان حضور در کاشان",
  insert_attend_time: "زمان حضور را وارد کنید",
  role: "نقش",
  website: "وب سایت",
  pay_number: "شماره کارت",
  national_code: "کد ملی",
  title: "عنوان",
  descriptions: "توضیحات",
  shop_descriptions: "توضیحات فروشگاه",
  insert_shop_descriptions: "توضیحات مربوط به این فروشگاه را وارد کنید",
  set_date_time: "تعیین زمان",
  country: "کشور",
  province: "استان",
  city: "شهر",
  birthday: "تاریخ تولد",
  phone_number: "شماره تلفن",
  telephone: "شماره تماس",
  set_time: "تعیین زمان",
  set_color: "تنظیم رنگ",
  count: "تعداد",
  product: "محصول",
  social_type: "نوع شبکه",
  social_address: "آدرس شبکه",
  type_of_product: "نوع محصول",
  create_new_country: "ایجاد کشور جدید",
  create_new_zone: "ایجاد استان / زون جدید",
  create_new_city: "ایجاد شهر جدید",

  create: "ایجاد",

  creator: "ایجاد کننده",

  company_name: "نام شرکت",
  company_color: "رنگ سازمانی",
  unit_product: "واحد شمارش محصول",

  edit_address: "ویرایش آدرس",
  add_new_address: "افزودن آدرس جدید",
  add_new_phone: "افزودن تلفن جدید",
  add_new_social: "افزودن شبکه اجتماعی جدید",
  add_new_email: "افزودن ایمیل جدید",

  effective_in_variation: "نمایش در تنوع محصولی",
  effective_in_variation_with_ratio: "نمایش در تنوع محصولی با ضریب قیمتی",
  price_ratio: "ضریب قیمت",
  unit_price: "قیمت واحد (تومان)",
  currency: "تومان",
  price_ratio_description:
    "در صورتی که میخواهید مقدار ویژگی در تنوع محصول نمایش داده شود اما در قیمت تاثیر نداشته باشد، مقدار صفر وارد نمایید",

  effective_in_variation_description:
    'در صورت انتخاب این گزینه، مقادیر انتخاب شده در "تنوع محصولی" و در غیر این صورت در "نام محصول" نمایش داده خواهند شد',

  no_attr_for_pick: "ویژگی برای انتخاب وجود ندارد",

  create_group_products: "ایجاد محصول گروهی",
  create_group_products_description:
    "ویژگی هایی از دسته انتخابی که مؤثر در تنوع محصول نیستند، به منظور ساخت چند محصول همزمان، به نام محصول اضافه می شود",

  server_error: "خطا در ارتباط با سرور",
  _404_error: "صفحه مورد نظر یافت نشد",
  connection_error: "لطفا از اتصال دستگاه خود به اینترنت مطمئن شوید",

  // inputs errors
  invalid_number: "فیلد باید از نوع عددی باشد",
  fill_input: "لطفا این قسمت را پر کنید",
  pick_input: "لطفا این قسمت را انتخاب کنید",
  title_is_required: "فیلد عنوان الزامی است",
  reminder_title_is_required: "عنوان یادآور الزامی است",
  reminder_date_is_required: "تاریخ یادآور الزامی است",
  reminder_time_is_required: "زمان یادآور الزامی است",
  customer_name_is_required: "نام مشتری الزامی است",
  customer_mobile_is_required: "موبایل مشتری الزامی است",
  mobile_is_required: "شماره موبایل الزامی است",
  invalid_mobile: "شماره وارد شده معتبر نمی باشد",
  invalid_count: "تعداد محصول باید از نوع عدد باشد",
  country_is_required: "انتخاب کشور الزامی است",
  province_is_required: "انتخاب  استان الزامی است",
  city_is_required: "انتخاب شهر الزامی است",
  address_is_required: "جزییات آدرس الزامی است",

  add_attrs_to_title: "افزودن ویژگی ها به عنوان محصول",

  // buttons labels
  today_factors_export: "خروجی روز",
  get_verify_code: "دریافت کد تایید",
  confirm_location: "تایید موقعیت",
  all: "همه",
  view_all: "مشاهده همه",
  sales: "فروش ها",
  factor_reports: "گزارش آماری فاکتورها",
  sellers_reports: "گزارش عملکرد مدیران",
  customer_reports: "گزارش تفکیک مشتریان",
  product_reports: "گزارش آماری محصولات",
  return: "بازگشت",
  add: "افزودن",
  active: "فعال",
  inactive: "غیرفعال",
  delete_avatar: "حذف تصویر",
  gallery: "گالری",
  files: "فایل ها",
  images: "تصاویر",
  camera: "دوربین",
  login: "ورود",
  logout: "خروج",
  submit_info: "ثبت اطلاعات",
  // edit_info: "ویرایش اطلاعات",
  edit_info: "ثبت اطلاعات",
  confirm: "تایید",
  cancel: "انصراف",
  completion_information: "تکمیل اطلاعات",
  new: "جدید",
  new_address: "آدرس جدید",
  new_phone: "تلفن جدید",
  new_email: "ایمیل جدید",
  new_social: "شبکه اجتماعی جدید",
  new_attr: "ویژگی جدید",
  send_verification_code: "ارسال کد تایید",
  no: "نه",
  yes: "بله",
  logout_from_account: "خروج از حساب",
  be_removed: "حذف شود",
  start: "شروع",

  // box labels
  done: "پیگیری شد",
  factor_done: "فاکتور تکمیل شد",
  price_affect: "",

  // CTA titles
  sellers: "مدیران فروش",
  add_seller: "افزودن مدیر فروش",
  edit_seller: "ویرایش مدیر فروش",
  customers: "مشتری ها",
  add_customer: "افزودن مشتری",
  products: "محصولات",
  add_product: "افزودن محصول",
  edit_product: "ویرایش محصول",
  reminders: "یادآور ها",
  reminders_archive: "آرشیو یادآور ها",
  add_reminder: "افزودن یادآور",
  factors: "فاکتور ها",
  factor: "فاکتور",
  factors_archive: "آرشیو فاکتور ها",
  add_factor: "افزودن فاکتور",
  notes: "یادداشت ها",
  notes_on: "یادداشت های مربوط به",
  tasks_on: "وظایف مربوط به",
  add_note: "افزودن یادداشت",
  product_attrs: "ویژگی های محصول",
  add_attr: "افزودن ویژگی",
  edit_attr: "ویرایش ویژگی",
  product_cats: "گروه بندی محصول",
  product_cat: "گروه محصول",
  add_cat: "افزودن گروه",
  edit_cat: "ویرایش گروه",
  today_reminders: "یادآورهای امروز",

  admin: "مدیر عامل",
  add_admin: "افزودن مدیر عامل",
  edit_admin: "ویرایش مدیر عامل",

  // header titles
  pick_customer_for: "انتخاب مشتری برای",
  add_reminder_for: "افزودن یادآور برای",
  add_factor_for: "افزودن فاکتور برای",
  add_task_for: "افزودن وظیفه جدید برای",
  add_note_for: "افزودن یادداشت برای",
  edit_reminder: "ویرایش یادآور",
  edit_factor: "ویرایش فاکتور",
  edit_note: "ویرایش یادداشت",
  account: "حساب کاربری",

  // reminder types
  birth: "تولد",
  own: "ثبت شده",
  system: "سیستمی",
  event: "مناسبتی",

  insert_title_search: "عنوان مورد جستجو را وارد کنید",
  insert_text_search: "عبارت مورد جستجو را وارد کنید",
  insert_name_search: "نام مورد جستجو را وارد کنید",
  insert_name: "نام را وارد کنید",

  filters: "فیلترها",
  apply_filters: "اعمال فیلتر",
  pick_customer: "مشتری مورد نظر را انتخاب کنید",
  pick_co_worker: "شرکت مورد نظر را انتخاب کنید",
  customer: "مشتری",
  type: "نوع",
  date: "تاریخ",

  search: "جستجو کنید",

  archive: "آرشیو",

  successTitle: "انجام شد",
  errorTitle: "خطا",
  warningTitle: "هشدار",
  infoTitle: "توجه",

  developed_by: "توسعه توسط",
  itsa: "فناوری اطلاعات آیتیسا",

  // info messages
  new_version_of_app_is_available: "نسخه جدید اپلیکیشن در دسترس است.",
  this_version_of_app_unusable: "نسخه جاری اپلیکیشن قابل استفاده نیست.",
  please_update_the_app:
    "لطفا برای استفاده از امکانات کامل برنامه، آن را بروزرسانی نمایید",

  send_code_again: "ارسال مجدد کد",
  did_not_receive_code: "هنوز کدی دریافت نکرده اید؟",
  no_category_products: "محصولی به این فاکتور افزوده نشده است",
  no_customer_address: "آدرسی برای این مشتری ثبت نشده است",
  no_customer_phone: "تلفنی برای این مشتری ثبت نشده است",
  no_customer_email: "ایمیلی برای این مشتری ثبت نشده است",
  no_customer_social: "شبکه اجتماعی برای این مشتری ثبت نشده است",
  no_item_attr: "مقداری برای این ویژگی ثبت نشده است",
  no_attr_cat: "ویژگی برای این گروه ثبت نشده است",
  no_attr_customer: "ویژگی برای این مشتری ثبت نشده است",
  no_customer: "مشتری یافت نشد",
  no_reminder: "یادآوری یافت نشد",
  no_task: "وظیفه‌ای یافت نشد",
  no_factor: "فاکتوری یافت نشد",
  no_note: "یادداشتی یافت نشد",
  no_wholesaler: "بنکداری یافت نشد",
  no_city: "شهری یافت نشد",
  no_country: "کشوری یافت نشد",
  no_province: "استانی یافت نشد",
  no_attr: "ویژگی یافت نشد",
  no_cat: "گروه بندی یافت نشد",
  no_product: "محصولی یافت نشد",
  no_seller: "مدیر فروشی یافت نشد",
  no_admin: "مدیر عاملی یافت نشد",
  no_company: "شرکتی یافت نشد",

  no_item_found: "موردی یافت نشد",

  // error toast messages
  fill_security_code: "کد تایید را وارد کنید",
  invalid_security_code: "کد تایید نا معتبر است",
  retry: "مشکلی در ارتباط با سرور رخ داده است. لطفا مجددا تلاش نمایید",
  invalid_time: "زمان انتخاب شده معتبر نیست",
  invalid_email: "ایمیل وارد شده معتبر نیست",
  invalid_national_code: "کد ملی وارد شده معتبر نیست",
  do_again: "تلاش مجدد",
  customer_credit: "اعتبار مشتری",

  // warning toast messages
  first_submit_changes: "ابتدا تغییرات را ثبت نمایید",
  not_exists_any_product_in_this_step: "هیچ محصولی در این مرحله وجود ندارد",
  app_not_allowed_location_permission: "مجوز دسترسی به موقعیت مکانی داده نشد",
  not_allow_to_change_empty_factor_status: "وضعیت فاکتور خالی قابل تغییر نیست",
  please_pick_country: "لطفا کشور را انتخاب کنید",
  please_pick_province: "لطفا استان را انتخاب کنید",
  fill_all_fields: "لطفا اطلاعات را بصورت کامل وارد نمایید",
  invalid_price: "قیمت نامعتبر است",
  can_not_edit_parent: "گروه پدر قابل ویرایش نیست",
  can_not_edit_product_cat: "گروه محصول قابل ویرایش نیست",
  latest_update: "آخرین ویرایش",
  varied_product_warning:
    "محصول انتخاب شده از نوع متنوع می باشد. لطفا ویژگی های این محصول را ثبت یا فعال کنید",
  not_allow_to_change_status: "شما اجازه تغییر وضعیت ندارید",
  // confirm questions
  are_you_sure_to_logout: "آیا برای خروج از حساب کاربری اطمینان دارید؟",
  are_you_sure_delete_this_item: "آیا از حذف این مورد اطمینان دارید؟",
  will_the_prices_be_updated: "آیا قیمت ها بروزرسانی شود؟",

  personal_characteristics: "خصوصیات شخصی و اخلاقی",
  insert_personal_characteristics: "خصوصیات شخصی و اخلاقی را وارد کنید",
  shop_name: "نام فروشگاه",
  insert_shop_name: "نام فروشگاه را وارد کنید",
  co_workers: "شرکت های همکار",
  location: "موقعیت روی نقشه",
  area: "متراژ",
  area_sample: "مثلا ۹۰",
  m2: "متر مربع",
  shop_owner: "وضعیت مالکیت",
  rental_time: "زمان اجاره",
  rental_sample: "مثلا ۴",
  sharer: "شریک",
  hasIt: "دارد",
  does_not_have: "ندارد",
  branch_count: "تعداد شعبه",
  branch_count_sample: "مثلا ۵",
  employee_count: "تعداد کارکنان",
  employee_count_sample: "مثلا ۲۳",
  regal_count: "تعداد رگال",
  regal_count_sample: "تعداد رگال را مشخص نمایید",
  must_selle_product: "محصول پر فروش",
  fav_pattern: "طرح مورد پسند",
  fav_color: "رنگ بندی مورد",
  usage_size: "سایز مورد استفاده",
  customer_type: "نوع مشتری",
  work_time: "مدت زمان فعالیت",
  other_job: "شغل دیگر صاحب مغازه",
  insert_other_job: "شغل دیگر صاحب مغازه را وارد کنید",
  religion: "دین و مذهب",
  work_time_in_kashan: "زمان حضور در کاشان",
  sensitivity: "حساسیت یا اهمیت بالا در مورد چیزی",

  country_name: "نام کشور",
  country_iso_code_2: "ایزو کد ۲",
  country_iso_code_3: "ایزو کد ۳",
  countery: "کشور",
  zone_name: "نام استان / زون",
  zone_slug: "اسلاگ استان / زون",
  zone_code: "کد استان / زون",
  zone: "استان / زون",
  city_name: "نام شهر",
  city_code: "کد شهر",

  // helper
  login_helper: {
    title: "به سرنخ خوش آمدید.",
    content_01:
      "در صورتی که مجوز ورود به برنامه را ندارید؛ برای دریافت دسترسی با شماره",

    content_02: "تماس حاصل فرمایید.",
  },

  support_phone: "09138717870",

  until_code_resent: (time: string) => `${time} تا ارسال مجدد کد`,

  organization: "سازمان",
  employee_roles_permissions: "کارمندان، نقش‌ها و مجوزها",
  employee: "کارمندان",
  roles: "نقش‌ها",
  permissions: "مجوزها",

  do_you_want_to_delete_the_role: (role: string) =>
    `آیا میخواهید نقش ${role} را پاک کنید؟`,

  do_you_want: "آیا میخواهید",
  to_delete_the: "را پاک کنید؟",

  permission_denied: "شما به این بخش دسترسی ندارید",
};

export default strings;
